// 活动管理类组件
import ETitle from '../view/event/module/title'
import ELine from '../view/event/module/line'
import EGuestA from '../view/event/module/guest-a'
import EGuestB from '../view/event/module/guest-b'
import ETextarea from '../view/event/module/textarea'

// 活动表单类组件
import FInput from '../view/form/module/Input/index'
import FRadioBox from '../view/form/module/RadioBox'
import FCheckBox from '../view/form/module/CheckBox/index'
import FSelectModule from '../view/form/module/SelectModule'
import FScoreModule from '../view/form/module/ScoreModule'
import FUpload from '../view/form/module/Upload/Upload'

let eventTypeList = {
  1: ETitle,
  3: ETextarea,
  4: ELine,
  5: EGuestA,
  6: EGuestB
}

/**
 * 题型：
 * Label          QuestionType = 1000000 // 仅标题
 * FillBlank      QuestionType = 100100  // 填空
 * 填空具体类型
 * Any               FillBlankType = 100101 // 任意
 * Name              FillBlankType = 100102 // 姓名
 * Email             FillBlankType = 100103 // 邮箱
 * Cellphone         FillBlankType = 100104 // 手机号
 * ThreeLevelAddress FillBlankType = 100105 // 三级联动地址
 * ThreeLevelDate    FillBlankType = 100108 // 三级联动日期
 * EnterpriseRealName          FillBlankType = 100170 //企业字段-姓名
 * EnterpriseEmail   FillBlankType = 100171 //企业字段-邮箱
 * EnterpriseDepartName FillBlankType = 100173 //企业字段-部门
 * EnterpriseAddress  FillBlankType = 100174 //企业字段-工作所在地
 *
 * Radio          QuestionType = 100200  // 单选
 * Common             RadioType = 100201 // 普通单选
 * InputRadio         RadioType = 100202 // 带输入框的单选
 *
 * MultiSelection QuestionType = 100300  // 多选
 * CommonMultiSelection MultiSelectionType = 100301 // 普通多选
 * InputMultiSelection                     = 100302 // 带输入框的多选
 * EnterpriseDirectionInterest = 100370 // 企业字段-感兴趣的内容
 * EnterpriseInternalTraining = 100370 // 企业字段-内训需求
 *
 * ComboBox       QuestionType = 100400  // 下拉框
 * CommonComboBox ComboBoxType = 100401 // 普通下拉
 * InputComboBox  ComboBoxType = 100402 // 带输入的下拉
 * EnterpriseIndustry ComboBoxType = 100470 // 企业字段-行业
 * EnterprisePosition ComboBoxType = 100471 // 企业字段-职位
 * EnterpriseTeamSize ComboBoxType = 100472 // 企业字段-团队规模
 * EnterpriseWorkYear ComboBoxType = 100473 // 企业字段-工作年限
 *
 * RichText       QuestionType = 100500  // 富文本
 *
 * Grade          QuestionType = 100600  // 评分组件
 * CommonGrade GradeType = 100601 //通用评分组件
 *
 * NPS            QuestionType = 100700  // NPS组件
 * CommonNPS NPSType = 100701 //通用NPS组件
 *
 * Uploader       QuestionType = 109900  // 上传组件
 * CommonUploader UploaderType = 109901 //通用上传
 */

let formTypeList = {
  100100: FInput,
  100200: FRadioBox,
  100300: FCheckBox,
  100400: FSelectModule,
  100600: FScoreModule,
  100700: FScoreModule,
  100800: FSelectModule,
  100900: FInput,
  109900: FUpload
}

export default {
  eventTypeList,
  formTypeList
}
